/**
 * @generated SignedSource<<8e84a5aca878a1736f52370ea59978e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "NO_PERMISSION" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_START" | "CANNOT_BE_COMPLETED" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
export type UpdateTaskInput = {
  ids?: ReadonlyArray<string | null> | null;
  projectId?: string | null;
  projectGroupId?: string | null;
  parentId?: string | null;
  phaseId?: string | null;
  aboveTaskId?: string | null;
  aboveFavouredTaskId?: string | null;
  name?: string | null;
  description?: string | null;
  estimateLow?: number | null;
  estimateHigh?: number | null;
  forecast?: number | null;
  timeLeft?: number | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  deadlineYear?: number | null;
  deadlineMonth?: number | null;
  deadlineDay?: number | null;
  roleId?: string | null;
  assignedPersons?: ReadonlyArray<string | null> | null;
  unassignAllPersons?: boolean | null;
  assignedPersonToAdd?: string | null;
  followers?: ReadonlyArray<string | null> | null;
  removeAllFollowers?: boolean | null;
  labels?: ReadonlyArray<string | null> | null;
  clearAllLabels?: boolean | null;
  sprintId?: string | null;
  projectGroupSprintId?: string | null;
  statusColumnId?: string | null;
  statusColumnV2Id?: string | null;
  projectGroupStatusColumnId?: number | null;
  coverFileId?: string | null;
  blocked?: boolean | null;
  bug?: boolean | null;
  approved?: boolean | null;
  billable?: boolean | null;
  repeatingTaskId?: string | null;
  unassignedTaskId?: string | null;
  previousProjectId?: string | null;
  unassignPersonFromTask?: ReadonlyArray<UnassignPersonFromTask | null> | null;
  remaining?: number | null;
  highPriority?: boolean | null;
  ownerId?: string | null;
  favoured?: boolean | null;
  favouredSortOrder?: string | null;
  parentTaskId?: string | null;
  deliverableId?: string | null;
  previousParentTaskId?: string | null;
  isBulkContext?: boolean | null;
  validateDependencies?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UnassignPersonFromTask = {
  taskId: string;
  personIds?: ReadonlyArray<string | null> | null;
};
export type ReorderProjectBoardTaskMutation$variables = {
  input: UpdateTaskInput;
};
export type ReorderProjectBoardTaskMutation$data = {
  readonly updateTask: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly taskEdge: {
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly sortOrder: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"DraggableCard_task">;
      } | null;
    } | null;
    readonly taskEdges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly sortOrder: number | null;
        readonly billable: boolean | null;
        readonly latestUiUpdateAt: string | null;
        readonly description: string | null;
        readonly timeLeft: number | null;
        readonly progress: number | null;
        readonly favouredSortOrder: string | null;
        readonly estimateForecastMinutes: number | null;
        readonly totalMinutesRegistered: number | null;
        readonly companyTaskId: number | null;
        readonly readOnly: {
          readonly isReadOnly: boolean | null;
        } | null;
        readonly userCanDeleteTask: boolean | null;
        readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
        readonly hasChildren: boolean | null;
        readonly sageIntacctId: string | null;
        readonly name: string | null;
        readonly favoured: boolean | null;
        readonly highPriority: boolean | null;
        readonly bug: boolean | null;
        readonly blocked: boolean | null;
        readonly startDay: number | null;
        readonly startMonth: number | null;
        readonly startYear: number | null;
        readonly deadlineDay: number | null;
        readonly deadlineMonth: number | null;
        readonly jiraId: string | null;
        readonly vstsId: string | null;
        readonly deadlineYear: number | null;
        readonly subTaskCount: number | null;
        readonly fileCount: number | null;
        readonly commentCount: number | null;
        readonly done: boolean | null;
        readonly parentTaskId: string | null;
        readonly hasInvoicedTime: boolean | null;
        readonly role: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly parentTask: {
          readonly name: string | null;
        } | null;
        readonly statusColumnV2: {
          readonly id: string;
          readonly category: STATUS_CATEGORY | null;
          readonly projectGroupStatusColumnId: number | null;
        } | null;
        readonly taskLabels: ReadonlyArray<{
          readonly id: string;
          readonly label: {
            readonly id: string;
            readonly name: string | null;
            readonly color: string | null;
          } | null;
        } | null> | null;
        readonly coverFile: {
          readonly id: string;
          readonly name: string | null;
          readonly key: string | null;
        } | null;
        readonly project: {
          readonly id: string;
          readonly companyProjectId: number | null;
          readonly projectColor: string | null;
          readonly name: string | null;
          readonly status: PROJECT_STATUS | null;
          readonly projectStartYear: number | null;
          readonly projectStartMonth: number | null;
          readonly projectStartDay: number | null;
          readonly projectEndYear: number | null;
          readonly projectEndMonth: number | null;
          readonly projectEndDay: number | null;
          readonly projectGroupId: string | null;
          readonly unit4Project: {
            readonly activitiesEnabled: boolean | null;
          } | null;
          readonly harvestProject: {
            readonly id: string;
          } | null;
          readonly client: {
            readonly name: string;
            readonly logoId: string | null;
            readonly logoDefaultId: number | null;
          } | null;
          readonly isProgramRevenueLocked: boolean | null;
          readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
          readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
        } | null;
        readonly thisTaskDependsOn: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly type: DEPENDENCY_TYPE | null;
              readonly thisDependsOnTask: {
                readonly statusColumnV2: {
                  readonly category: STATUS_CATEGORY | null;
                } | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly dependsOnThisTask: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly type: DEPENDENCY_TYPE | null;
              readonly taskDependsOnThis: {
                readonly id: string;
                readonly statusColumnV2: {
                  readonly category: STATUS_CATEGORY | null;
                } | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly assignedPersons: ReadonlyArray<{
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly fullName: string | null;
          readonly email: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
          readonly active: boolean | null;
          readonly permissions: ReadonlyArray<string | null> | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null> | null;
    readonly sortOrderTasks: ReadonlyArray<{
      readonly id: string;
      readonly sortOrder: number | null;
    } | null> | null;
    readonly updatedTasksIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type ReorderProjectBoardTaskMutation = {
  variables: ReorderProjectBoardTaskMutation$variables;
  response: ReorderProjectBoardTaskMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favouredSortOrder",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastMinutes",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalMinutesRegistered",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isReadOnly",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTaskCount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileCount",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectGroupStatusColumnId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskLabel",
  "kind": "LinkedField",
  "name": "taskLabels",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v20/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "coverFile",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activitiesEnabled",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoId",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoDefaultId",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProgramRevenueLocked",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programBudgetType",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v40/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "assignedPersons",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureDefaultId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    (v39/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "sortOrderTasks",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedTasksIds",
  "storageKey": null
},
v67 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskReadOnly",
      "kind": "LinkedField",
      "name": "readOnly",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "parentTask",
      "plural": false,
      "selections": [
        (v20/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v44/*: any*/),
        (v45/*: any*/),
        (v20/*: any*/),
        (v46/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/),
        (v49/*: any*/),
        (v50/*: any*/),
        (v51/*: any*/),
        (v52/*: any*/),
        (v53/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Unit4ProjectType",
          "kind": "LinkedField",
          "name": "unit4Project",
          "plural": false,
          "selections": [
            (v54/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v55/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v56/*: any*/),
            (v57/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v58/*: any*/),
        (v59/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customProjectId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v67/*: any*/),
      "concreteType": "DependencyTypeConnection",
      "kind": "LinkedField",
      "name": "thisTaskDependsOn",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DependencyType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v60/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "thisDependsOnTask",
                  "plural": false,
                  "selections": [
                    (v68/*: any*/),
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                (v62/*: any*/)
              ],
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v63/*: any*/)
      ],
      "storageKey": "thisTaskDependsOn(first:1000)"
    },
    {
      "alias": null,
      "args": (v67/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "Task_thisTaskDependsOn",
      "kind": "LinkedHandle",
      "name": "thisTaskDependsOn"
    },
    {
      "alias": null,
      "args": (v67/*: any*/),
      "concreteType": "DependencyTypeConnection",
      "kind": "LinkedField",
      "name": "dependsOnThisTask",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DependencyType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v60/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "taskDependsOnThis",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    (v68/*: any*/)
                  ],
                  "storageKey": null
                },
                (v62/*: any*/)
              ],
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v63/*: any*/)
      ],
      "storageKey": "dependsOnThisTask(first:1000)"
    },
    {
      "alias": null,
      "args": (v67/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "Task_dependsOnThisTask",
      "kind": "LinkedHandle",
      "name": "dependsOnThisTask"
    },
    (v64/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReorderProjectBoardTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DraggableCard_task"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskReadOnly",
                    "kind": "LinkedField",
                    "name": "readOnly",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "parentTask",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v20/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Unit4ProjectType",
                        "kind": "LinkedField",
                        "name": "unit4Project",
                        "plural": false,
                        "selections": [
                          (v54/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v55/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v56/*: any*/),
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v58/*: any*/),
                      (v59/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "DeprecatedProjectIndicatorJS_project"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "thisTaskDependsOn",
                    "args": null,
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_thisTaskDependsOn_connection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DependencyTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DependencyType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "thisDependsOnTask",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v63/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "dependsOnThisTask",
                    "args": null,
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_dependsOnThisTask_connection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DependencyTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DependencyType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "taskDependsOnThis",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v61/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v62/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v63/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v64/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v65/*: any*/),
          (v66/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReorderProjectBoardTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v69/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdges",
            "plural": true,
            "selections": [
              (v69/*: any*/)
            ],
            "storageKey": null
          },
          (v65/*: any*/),
          (v66/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9b647abf32c4716c13d901048c6f95d3",
    "id": null,
    "metadata": {},
    "name": "ReorderProjectBoardTaskMutation",
    "operationKind": "mutation",
    "text": "mutation ReorderProjectBoardTaskMutation(\n  $input: UpdateTaskInput!\n) {\n  updateTask(input: $input) {\n    errors\n    taskEdge {\n      cursor\n      node {\n        id\n        sortOrder\n        ...DraggableCard_task\n      }\n    }\n    taskEdges {\n      node {\n        id\n        sortOrder\n        billable\n        latestUiUpdateAt\n        description\n        timeLeft\n        progress\n        favouredSortOrder\n        estimateForecastMinutes\n        totalMinutesRegistered\n        companyTaskId\n        readOnly {\n          isReadOnly\n          id\n        }\n        userCanDeleteTask\n        userCantDeleteTaskReason\n        hasChildren\n        sageIntacctId\n        name\n        favoured\n        highPriority\n        bug\n        blocked\n        startDay\n        startMonth\n        startYear\n        deadlineDay\n        deadlineMonth\n        jiraId\n        vstsId\n        deadlineYear\n        subTaskCount\n        fileCount\n        commentCount\n        done\n        parentTaskId\n        hasInvoicedTime\n        role {\n          id\n          name\n        }\n        parentTask {\n          name\n          id\n        }\n        statusColumnV2 {\n          id\n          category\n          projectGroupStatusColumnId\n        }\n        taskLabels {\n          id\n          label {\n            id\n            name\n            color\n          }\n        }\n        coverFile {\n          id\n          name\n          key\n        }\n        project {\n          id\n          companyProjectId\n          projectColor\n          name\n          status\n          projectStartYear\n          projectStartMonth\n          projectStartDay\n          projectEndYear\n          projectEndMonth\n          projectEndDay\n          projectGroupId\n          unit4Project {\n            activitiesEnabled\n            id\n          }\n          harvestProject {\n            id\n          }\n          client {\n            name\n            logoId\n            logoDefaultId\n            id\n          }\n          isProgramRevenueLocked\n          programBudgetType\n          ...DeprecatedProjectIndicatorJS_project\n        }\n        thisTaskDependsOn(first: 1000) {\n          edges {\n            node {\n              id\n              type\n              thisDependsOnTask {\n                statusColumnV2 {\n                  category\n                  id\n                }\n                id\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        dependsOnThisTask(first: 1000) {\n          edges {\n            node {\n              id\n              type\n              taskDependsOnThis {\n                id\n                statusColumnV2 {\n                  category\n                  id\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        assignedPersons {\n          id\n          firstName\n          lastName\n          fullName\n          email\n          profilePictureId\n          profilePictureDefaultId\n          active\n          permissions\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n    sortOrderTasks {\n      id\n      sortOrder\n    }\n    updatedTasksIds\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment DraggableCard_task on Task {\n  id\n  billable\n  latestUiUpdateAt\n  description\n  timeLeft\n  progress\n  favouredSortOrder\n  estimateForecastMinutes\n  totalMinutesRegistered\n  companyTaskId\n  readOnly {\n    isReadOnly\n    id\n  }\n  userCanDeleteTask\n  userCantDeleteTaskReason\n  hasChildren\n  sageIntacctId\n  name\n  favoured\n  highPriority\n  bug\n  blocked\n  startDay\n  startMonth\n  startYear\n  deadlineDay\n  deadlineMonth\n  jiraId\n  vstsId\n  deadlineYear\n  subTaskCount\n  fileCount\n  commentCount\n  done\n  parentTaskId\n  hasInvoicedTime\n  role {\n    id\n    name\n  }\n  parentTask {\n    name\n    id\n  }\n  statusColumnV2 {\n    id\n    category\n    projectGroupStatusColumnId\n  }\n  taskLabels {\n    id\n    label {\n      id\n      name\n      color\n    }\n  }\n  coverFile {\n    id\n    name\n    key\n  }\n  project {\n    id\n    companyProjectId\n    projectColor\n    name\n    status\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    projectGroupId\n    unit4Project {\n      activitiesEnabled\n      id\n    }\n    harvestProject {\n      id\n    }\n    client {\n      name\n      logoId\n      logoDefaultId\n      id\n    }\n    isProgramRevenueLocked\n    programBudgetType\n    ...DeprecatedProjectIndicatorJS_project\n  }\n  thisTaskDependsOn(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        thisDependsOnTask {\n          statusColumnV2 {\n            category\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  dependsOnThisTask(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        taskDependsOnThis {\n          id\n          statusColumnV2 {\n            category\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  assignedPersons {\n    id\n    firstName\n    lastName\n    fullName\n    email\n    profilePictureId\n    profilePictureDefaultId\n    active\n    permissions\n    role {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "453971d0b4366d71a4c8e121bf1d3992";

export default node;
